import {
    AuthorizationList,
    CanAccess,
} from "../../../components/template/authorization/Authorization";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import { Button } from "antd";

export const initFilterInput = {
    searchName: "",
    page: 1,
    pageSize: 10,
    transactionStartDate: null,
    transactionEndDate: null,
    sortingField: null,
    sortingOrder: null,
};

export const renderColumns = (handleProses, handleDetail) => {
    return [
        {
            dataIndex: "req_kirim",
            key: "req_kirim",
            title: "Request Waktu Kirim",
            sorter: true,
            backend_key: "delivery_date",
        },
        {
            dataIndex: "req_kirim",
            backend_key: "req_kirim",
            key: "req_kirim",
            title: "Tanggal & Waktu Kirim",
        },
        {
            dataIndex: "no_sbg",
            key: "no_sbg",
            title: "No. SBG",
        },
        {
            dataIndex: "nama_nasabah",
            key: "nama_nasabah",
            title: "Nama Nasabah",
        },
        {
            dataIndex: "no_telp",
            key: "no_telp",
            title: "No. Telepon ",
        },
        {
            dataIndex: "barang_jaminan",
            key: "barang_jaminan",
            title: "Barang Jaminan ",
        },
        {
            dataIndex: "lokasi",
            key: "lokasi",
            title: "Lokasi Barang",
        },
        {
            dataIndex: "lokasi_kirim",
            key: "lokasi_kirim",
            title: "Lokasi Kirim",
        },
        {
            dataIndex: "konfirmasi",
            key: "konfirmasi",
            title: "Konfirmasi Sebelum",
            render: (text) => (
                <div
                    style={{
                        textAlign: "left",
                        color: "red",
                        fontWeight: "bold"
                    }}
                >
                    {text}
                </div>
            ),
        },
        {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "10%",
            render: (_, record) => (
                <div className="d-flex flex-column">
                    <div className="mr-2 mb-2">
                        <CanAccess
                            role={AuthorizationList.update_delivery_gadai}
                            yes={
                                <Button
                                    variant="primary"
                                    className="btn-action btn-detail"
                                    onClick={() => handleProses(record)}>
                                    Konfirmasi Jadwal
                                </Button>
                            }
                        />
                    </div>
                    <div className="mr-2 mb-2">
                        <div className="mr-2">
                            <Button
                                variant="primary"
                                className="btn-action btn-default font-weight-semi-bold border-2C465C"
                                onClick={() => handleDetail(record)}
                                style={{ width: "145px" }}
                            >
                                Detail
                            </Button>
                        </div>
                    </div>
                </div>
            ),
        },
    ];
};
